import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import { useState, useEffect } from 'react';
import { URL } from '../../common/api/urls';
import { PayoffChart } from './components/payoff_chart_component.js';
import { PayoffHeader } from './components/payoff_header.js';
import { WATERMARK_CONFIG } from '../../common/utility/constant';


export default function PAYOFF_CHART() {
  const [cancelPayoff, responseDataPayoff, errorPayoff, loadedPayoff, resetPayoff, executeAPIPayoff] = useAxiosWithAuth();
  // const [size, setSize] = useState(75);
  const [selectedInstrumentData, setSelectedInstrumentData] = useState([
        // {
        //   "instrument": "O_NIFTY24800CE20250710",
        //   "size": 1
        // }
      ]);
  const [dateList, setDateList] = useState([]); 
  const [callApi, setCallApi] = useState(false);

useEffect(() => {
  document.title = "Payoff Charts";
}, []);

useEffect(() => {
  if (!callApi) {
    return;
  }
  let data = {
    instruments: selectedInstrumentData,
    payoff_per_option: false,
  };
  if (dateList && dateList.length > 0) {
    data = {
      instruments: selectedInstrumentData,
      payoff_per_option: false,
      target_dates: dateList.map(item => ({
        tDate: item.targetDate,
        tTime: item.targetTime,
      })),
    };
  }
  console.log('Executing API with data:', data);
  resetPayoff();
  executeAPIPayoff(URL.PAYOFFCHART, "POST", data);
}, [selectedInstrumentData, dateList]);



  const handleInstrumentSelect = ({instrumentData, dateData}) => {

    console.log('handleInstrumentSelect called with:', {instrumentData, dateData});

    if (!instrumentData || instrumentData.length === 0) {
      setSelectedInstrumentData([]);
      setDateList([]);
      return;
    }
    if(instrumentData && instrumentData.length > 0) {
      setSelectedInstrumentData(instrumentData);
      setCallApi(true);
      setDateList([]);
    }
    if (dateData && dateData.length > 0) {
      // setSelectedInstrumentData(instrumentData)
      setDateList(dateData);
      setCallApi(true);
    }
    //debug
    console.log('Updated selected instruments:', instrumentData);

    if (instrumentData) {
      console.log(`Selected: ${instrumentData.name} (${instrumentData.instr})`);
    }
    setCallApi(true);
  };

  return (
    <div style={{
      display: "flex", 
      flexDirection: "column", 
      width: "100%",
      backgroundColor: "#0d203f",
      minHeight: "calc(100vh - 64px)"
    }}>
    <div
      id="watermark"
      className="watermark"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <span>{WATERMARK_CONFIG.TEXT}</span>
    </div>

      {/* Main content container with responsive layout */}
      <div style={{
        display: "flex", 
        flexDirection: "row", 
        flexWrap: "wrap",
        width: "100%",
        gap: "20px",
        padding: "20px"
      }}>
        {/* Left column - Controls */}
        <div style={{
          flex: "1 1 400px",
          minWidth: "350px",
          maxWidth: "100%",
          order: 1
        }}>
          <PayoffHeader
            onInstrumentSelect={handleInstrumentSelect} 
            plotInstrumentList={responseDataPayoff?.instrument_list}
            currentDateTime={responseDataPayoff?.current_date + " " + responseDataPayoff?.current_time}
            posDelta={responseDataPayoff?.combined_delta}
          />
        </div>
        
        {/* Right column - Chart */}
        <div style={{
          flex: "2 1 600px",
          minWidth: "350px",
          maxWidth: "100%",
          order: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start"
        }}>
          {selectedInstrumentData.length != 0 || responseDataPayoff?.fut_ltp ? (
            <PayoffChart
              payoffData={responseDataPayoff}
              futLtp={responseDataPayoff?.fut_ltp}
              oldFutLtp={responseDataPayoff?.old_fut_ltp}
              isLoading={!loadedPayoff && !errorPayoff}
              error={errorPayoff}
            />
          ) : (
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "300px",
              width: "100%",
              color: "#FFFFFF",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              borderRadius: "8px",
              fontSize: "16px"
            }}>
              Please select instruments to view the payoff chart
            </div>
          )}
        </div>
      </div>
    </div>
  );
}